import React, { Component, Fragment } from "react";

import { connect } from "react-redux";
// connect gives as access to state from redux store
import _ from "lodash";
import PropTypes from "prop-types";
import { logout, removeGreetings } from "../actions/authActions";
import { changePage } from "../actions/changePageAction";
import { clearErrors } from "../actions/errorActions";
import { getProjects } from "../actions/projectActions";
import { changeLanguage, updateUser } from "../actions/userActions";
import {
  deleteProfilePictures,
  pictureDownload,
} from "./../actions/pictureAction";
import i18n from "./helper/i18n";
import { Translation } from "./helper/transComp";
// import FilterLink from "./container/FilterLink";
import {
  Button,
  Container,
  Modal,
  Nav,
  Navbar,
  NavDropdown,
  Offcanvas,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import NavigationLink from "./container/NavigationLink";
import ProfileLink from "./container/ProfileLink";
// import { WebSocketContext } from "./../WebSocket";
import { WebsocketContext } from "./../WebsocketContext";
import { FolderBlack } from "./../components/helper/icon/icon";
import OutsideAlerter from "./helper/functions/OutsideAlerter";
// import { openWSConnection } from "../actions/websocketAction";
// import { getWSService } from "../WSService";
// import { wsRoomInit } from "../WSRoom";

class HeaderLoggedIn extends Component {
  static contextType = WebsocketContext;
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      width: 0,
      height: 0,
      displMenu: false,
      languages: ["en", "de", "fr"],
      currLan: "en",
      register: false,
      login: false,
      images: [],
      isAuthenticated: false,
      displayModal: false,
      displayHelp: false,
      projObj: {},
      homeObj: {},
      addProjObj: {},
      addItemObj: {},
      addTaskObj: {},
      addChartObj: {},
      currHelp: -1,
      navbarExpanded: false,
      videoSrc: "create_project_ws_EN.mp4",
      displayChat: false,
      profilePopupOpen: false,
      showNewsLetter: 4,
      // displayGreetings: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  intervalID1 = 1;
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    if (this.props.user) {
      if (this.props.user.user) {
        if (this.props.user.user.language) {
          if (
            this.props.user.user.language !== "" &&
            this.props.user.user.language !== undefined
          ) {
            this.props.updateUser({
              modUser: true,
              language: this.props.user.language,
            });
            let videoSrc = "create_project_ws_EN.mp4";
            if (this.props.user.user.language === "de") {
              videoSrc = "create_project_ws_DE.mp4";
            } else if (this.props.user.user.language === "fr") {
              videoSrc = "create_project_ws_FR.mp4";
            }
            this.setState({ videoSrc });
          } else {
            this.props.updateUser({
              modUser: true,
            });
          }
        } else {
          this.props.updateUser({
            modUser: true,
          });
        }
        this.props.updateUser({
          modUser: true,
          updateAddressBook: true,
        });
      } else {
        this.props.updateUser({
          modUser: true,
        });
      }
    } else {
      this.props.updateUser({
        modUser: true,
      });
    }
    if (this.context) {
      if (this.context.connect) {
        this.context.connect();
      }
    }
    // if (this.context.setConnected) {

    //   this.context.setConnected(true);
    // }
    this.checkLogIn();
    this.intervalID1 = setInterval((e) => this.checkLogIn(), 300000); //every 5 min
    if (this.props.auth.greetings) {
      setTimeout(() => {
        this.props.removeGreetings();
      }, 5 * 60 * 1000);
    }
    // this.context.connect();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
    clearInterval(this.intervalID1);
  }

  componentDidUpdate() {
    const { isAuthenticated } = this.props;
    if (this.state.isAuthenticated !== isAuthenticated) {
      this.setState({ isAuthenticated });
      if (this.props.picture.images)
        if (!this.props.picture.images.length) {
          if (!this.props.picture.images.user) this.props.pictureDownload();
        }
    }
    if (this.state.login || this.state.register) {
      if (isAuthenticated) {
        this.setState({
          login: false,
          register: false,
          isOpen: false,
        });
        this.props.changePage("home");
        this.props.clearErrors();
      }
    }
    if (this.props.picture !== undefined) {
      if (this.props.picture.images !== undefined) {
        if (this.props.picture.images !== this.state.images) {
          this.setState({ images: this.props.picture.images });
        }
      }
    }
    if (this.props.user)
      if (this.props.user.user)
        if (this.props.user.user.language)
          if (this.props.user.user.language !== this.state.currLan) {
            i18n.changeLanguage(this.props.user.user.language);
            this.setState({ currLan: this.props.user.user.language });
          }
  }

  static propTypes = {
    auth: PropTypes.object.isRequired,
    changePage: PropTypes.func.isRequired,
    page: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    getProjects: PropTypes.func.isRequired,
    picture: PropTypes.object,
    logout: PropTypes.func.isRequired,
    deleteProfilePictures: PropTypes.func.isRequired,
    pictureDownload: PropTypes.func.isRequired,
    updateUser: PropTypes.func.isRequired,
    changeLanguage: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
  };

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth });
  }

  checkLogIn() {
    if (Date.now() > this.props.auth.loginTimestamp + 34200000) {
      this.setState({ displayModal: true });
    }
    if (Date.now() > this.props.auth.loginTimestamp + 37800000) {
      this.props.logout();
    }
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  displayPage = (e, pageTitle) => {
    e.preventDefault();
    this.props.changePage(pageTitle);
  };

  getLangTxt = () => {
    switch (this.props.user.language) {
      case "de":
        return "DE";
      case "fr":
        return "FR";
      default:
        return "EN";
    }
  };

  render() {
    let userImg = (
      <img
        className="profilePic"
        src={`/img/user.png`}
        alt={"profil"}
        style={{
          width: "40px",
          height: "40px",
        }}
      />
    );

    return (
      <Fragment>
        {/* <Modal
          show={this.props.auth.greetings === true}
          onHide={() => this.props.removeGreetings()}
          // dialogClassName="modal-large"
          size={"lg"}
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              <Translation str={"HeaderNews"} />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              <Translation str={"HeaderGreetings1"} />{" "}
              {this.props.user
                ? this.props.user.user
                  ? this.props.user.user.firstName
                    ? this.props.user.user.firstName
                    : null
                  : null
                : null}
              ,
            </p>

            <p style={{ marginTop: "1rem" }}>
              <Translation str={"HeaderGreetings2"} />
            </p>
            <p style={{ marginTop: "1.5rem" }}>
              <div style={{ fontSize: "20px", fontWeight: "700" }}>
                <Translation str={"HeaderNewFeatures"} />
              </div>
              <div style={{ maxWidth: "1280px", marginTop: "1rem" }}>
                <video controls width="100%" loop className="blog-video">
                  <source
                    // muted
                    src="https://luckiwipublic.s3.eu-central-1.amazonaws.com/newsletter/newsletter+5.mp4"
                    // src="https://luckiwipublic.s3.eu-central-1.amazonaws.com/newsletter/newsletter+4+-+actualite+du+mois+d+octobre_v1.mp4"
                    type="video/mp4"
                  />
                  {/* <Translation str={"KabanVideo"} />
                </video>
              </div>
            </p>
            <Button
              variant="submit100"
              style={{ width: "100%", borderRadius: "10px" }}
              onClick={() => {
                this.setState({
                  displayHelp: true,
                  currVideo: 2,
                  showNewsLetter: true,
                });
                this.props.removeGreetings();
              }}
            >
              Voir l'intégralité de la newsletter.
            </Button>
          </Modal.Body>
        </Modal> */}
        {/* <Modal
          show={this.state.displayHelp}
          onHide={() => this.setState({ displayHelp: false })}
          // dialogClassName="modal-large"
          size={"lg"}
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              <Translation str={"HeaderCanHelp"} />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Translation str={"HeaderQuestions"} />
            <a href="mailto:support@luckiwi.com" style={{ color: "black" }}>
              support@luckiwi.com.
            </a>
            <div style={{ display: "flex" }}>
              <div className="headerHelpMenuVideoBoxLeft">
                <div
                  className="headerHelpMenuButton"
                  style={
                    this.state.showNewsLetter === 4
                      ? { backgroundColor: "#008910", color: "white" }
                      : null
                  }
                  onClick={() => {
                    this.setState({ showNewsLetter: 4 });
                  }}
                >
                  <Translation str={"ResourcePlanningJun"} /> 2025
                </div>
                <div
                  className="headerHelpMenuButton"
                  style={
                    this.state.showNewsLetter === 3
                      ? { backgroundColor: "#008910", color: "white" }
                      : null
                  }
                  onClick={() => {
                    this.setState({ showNewsLetter: 3 });
                  }}
                >
                  <Translation str={"ResourcePlanningMay"} /> 2025
                </div>
                <div
                  className="headerHelpMenuButton"
                  style={
                    this.state.showNewsLetter === 2
                      ? { backgroundColor: "#008910", color: "white" }
                      : null
                  }
                  onClick={() => {
                    this.setState({ showNewsLetter: 2 });
                  }}
                >
                  <Translation str={"ResourcePlanningMar"} /> 2025
                </div>
                <div
                  className="headerHelpMenuButton"
                  style={
                    this.state.showNewsLetter === 1
                      ? { backgroundColor: "#008910", color: "white" }
                      : null
                  }
                  onClick={() => {
                    this.setState({ showNewsLetter: 1 });
                  }}
                >
                  <Translation str={"ResourcePlanningFeb"} /> 2025
                </div>
                <div
                  className="headerHelpMenuButton"
                  style={
                    this.state.showNewsLetter === 0
                      ? { backgroundColor: "#008910", color: "white" }
                      : null
                  }
                  onClick={() => {
                    this.setState({ showNewsLetter: 0 });
                  }}
                >
                  <Translation str={"ResourcePlanningOct"} /> 2024
                </div>
              </div>
              <div
                className="headerHelpMenuVideoBoxRight"
                style={{ maxHeight: "350px", overflow: "scroll" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    color: "#008910",
                    margin: "20px 0",
                  }}
                >
                  {this.state.showNewsLetter == 0 ? (
                    <video
                      id="help-video"
                      controls
                      width="100%"
                      key={this.state.showNewsLetter}
                    >
                      <source
                        id="help-videosrc"
                        src={
                          "https://luckiwipublic.s3.eu-central-1.amazonaws.com/newsletter/newsletter+4+-+actualite+du+mois+d+octobre_v1.mp4"
                        }
                        type="video/mp4"
                      />
                      Sorry, your browser doesn't support embedded videos.
                    </video>
                  ) : this.state.showNewsLetter == 1 ? (
                    <video
                      id="help-video"
                      controls
                      width="100%"
                      key={this.state.showNewsLetter}
                    >
                      <source
                        id="help-videosrc"
                        src={
                          "https://luckiwipublic.s3.eu-central-1.amazonaws.com/newsletter/newsletter_2025_01.mp4"
                        }
                        type="video/mp4"
                      />
                      Sorry, your browser doesn't support embedded videos.
                    </video>
                  ) : this.state.showNewsLetter == 2 ? (
                    <video
                      id="help-video"
                      controls
                      width="100%"
                      key={this.state.showNewsLetter}
                    >
                      <source
                        id="help-videosrc"
                        src={
                          "https://luckiwipublic.s3.eu-central-1.amazonaws.com/newsletter/newsletter2_final.mp4"
                        }
                        type="video/mp4"
                      />
                      Sorry, your browser doesn't support embedded videos.
                    </video>
                  ) : this.state.showNewsLetter == 3 ? (
                    <video
                      id="help-video"
                      controls
                      width="100%"
                      key={this.state.showNewsLetter}
                    >
                      <source
                        id="help-videosrc"
                        src={
                          "https://luckiwipublic.s3.eu-central-1.amazonaws.com/newsletter/newsletter3_final.mp4"
                        }
                        type="video/mp4"
                      />
                      Sorry, your browser doesn't support embedded videos.
                    </video>
                  ) : (
                    <video
                      id="help-video"
                      controls
                      width="100%"
                      key={this.state.showNewsLetter}
                    >
                      <source
                        id="help-videosrc"
                        src={
                          "https://luckiwipublic.s3.eu-central-1.amazonaws.com/newsletter/newsletter+5.mp4"
                        }
                        type="video/mp4"
                      />
                      Sorry, your browser doesn't support embedded videos.
                    </video>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal> */}
        <div>
          <Navbar
            bg="light"
            expand="md"
            fixed="top"
            key={"md"}
            className="mb-3"
            expanded={this.state.navbarExpanded}
            onToggle={() => {
              this.setState({
                navbarExpanded: !this.state.navbarExpanded,
              });
            }}
          >
            <Container>
              <img
                src={`/img/logo.webp`}
                alt={"logo"}
                style={{
                  height: "60px",
                }}
              />
              <Navbar.Toggle
                aria-controls="responsive-navbar-nav"
                style={{ background: "#a1c5a3", marginRight: "10px" }}
              />
              <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="me-0 ms-auto">
                  <div style={{ margin: "9px auto", fontWeight: "700" }}>
                    <NavigationLink
                      navLinkClicked={() => {
                        this.setState({ isOpen: false });
                      }}
                      target={true}
                      id="headerForBackground"
                      filter={`./${this.state.currLan}/register`}
                    >
                      <span id="backgrounded">
                        <Translation str={"HeaderFreePremium"} />
                      </span>
                    </NavigationLink>
                  </div>
                  <NavDropdown
                    title={
                      this.props.user.language !== this.state.currLan ? (
                        <span
                          style={{
                            color: "#424141",
                            fontWeight: "bold",
                            display: "flex",
                          }}
                        >
                          <img
                            src={"/img/world.svg"}
                            alt="language"
                            style={{ width: "20px", marginRight: "2.5px" }}
                          />{" "}
                          {this.getLangTxt(this.props.user.language)}
                        </span>
                      ) : (
                        <span style={{ color: "#424141" }}>
                          <img
                            src={"/img/world.svg"}
                            alt="language"
                            style={{ width: "20px" }}
                          />{" "}
                          {this.getLangTxt(this.props.user.language)}
                        </span>
                      )
                    }
                    id="basic-nav-dropdown-topnav"
                  >
                    {_.map(this.state.languages, (tval, tind) => {
                      return (
                        <NavDropdown.Item
                          className={"hoverMenu buttonContainerStart"}
                          style={{
                            backgroundColor:
                              this.state.currLan === tval ? "#d6d6d6" : "",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            this.setState({
                              currLan: tval,
                              isOpen: false,
                              navbarExpanded: false,
                            });
                            i18n.changeLanguage(tval);
                            this.props.updateUser({
                              modUser: true,
                              language: tval,
                            });
                          }}
                          key={tind}
                        >
                          <span
                            style={{ marginLeft: "0.25rem", cursor: "pointer" }}
                          >
                            {tval === "en" ? (
                              <>
                                <img
                                  src={`/img/english.webp`}
                                  style={{
                                    height: "30px",
                                    margin: "0 10px 0 5px",
                                  }}
                                />
                                <span>English </span>
                              </>
                            ) : tval === "de" ? (
                              <>
                                <img
                                  src={`/img/german.webp`}
                                  style={{
                                    height: "30px",
                                    margin: "0 10px 0 5px",
                                  }}
                                />
                                <span>Deutsch</span>
                              </>
                            ) : (
                              <>
                                <img
                                  src={`/img/french.webp`}
                                  style={{
                                    height: "30px",
                                    margin: "0 10px 0 5px",
                                  }}
                                />
                                <span>Français</span>
                              </>
                            )}
                          </span>
                        </NavDropdown.Item>
                      );
                    })}
                  </NavDropdown>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </div>{" "}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  page: state.page,
  isAuthenticated: state.auth.isAuthenticated,
  picture: state.picture,
  user: state.user,
  ws: state.ws,
  company: state.company,
  // this is props so add prop type
});

export default connect(mapStateToProps, {
  changePage,
  clearErrors,
  getProjects,
  logout,
  deleteProfilePictures,
  pictureDownload,
  updateUser,
  changeLanguage,
  removeGreetings,
})(HeaderLoggedIn);
